import React from "react";

export default function Loading() {
    return (
        <div className="justify-content-center row mt-5">
            <img className="loading-img" src={require("assets/img/theme/loading.gif")} alt="loading" />
        </div>
    );
}